<template>
  <div class="h-full p-sm pt-2xl">
    <h2 class="type-heading-md mb-md text-3xl">Ärendehantering</h2>
    <avtalat-tabs
      :tabs="[
        {
          name: 'Nytt ärende',
          id: 'new-arende',
        },
      ]"
    >
      <avtalat-tabs-item id="new-arende">
        <div class="flex flex-col gap-sm" v-if="arendeCreated">
          <avtalat-message type="positive" small
            ><p>Ärendet har sparats</p></avtalat-message
          >
          <a class="self-end no-underline" v-on:click="newArende" href="#"
            >Nytt ärende</a
          >
        </div>
        <UnlinkedArendeForm v-else />
      </avtalat-tabs-item>
    </avtalat-tabs>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import UnlinkedArendeForm from "./arende-management/UnlinkedArendeForm.vue";

const arendeCreated = ref(false);
const newArende = () => {
  arendeCreated.value = false;
};
</script>
